<template>
    <modal
        v-if="show"
        :form="form"
        confirm
        type="is-danger"
        size="is-xsmall"
        :title="titleModal"
        submit-text="Delete"
        @submit="handleSubmit"
        @closed="handleClosed"
    >
        Are you sure you want to delete this CNAM {{ item.name }}? This can not be undone.
    </modal>
</template>

<script>
import Form from 'core/Form';
import { mapState } from 'pinia';
import stores from 'store/modules';

export default {
    data: () => ({
        form: new Form({
            id: null,
        }),
    }),

    computed: {
        item() {
            return this.showCNAMItem;
        },

        show() {
            return this.showCNAMDeleteModal;
        },

        titleModal() {
            return `Delete CNAM ${this.item.name}`;
        },

        ...mapState(stores.ComplianceProfile, ['CNAMCallerProfile', 'shakenStirProfile']),
        ...mapState(stores.CallingStore, ['showCNAMItem', 'showCNAMDeleteModal']),
    },

    watch: {
        show(value) {
            if (value) {
                this.init();
            }
        },
    },

    methods: {
        init() {
            this.reset();
        },

        reset() {
            this.form.reset();
        },

        handleClosed() {
            this.$store.dispatch('handleShowCNAMDeleteModal', {
                status: false,
                item: null,
            });
            this.$emit('closed');
        },

        async handleSubmit() {
            try {
                this.form.id = this.item.id;
                await this.$store.dispatch('deleteCNAMCaller', this.form);
                if (!this.CNAMCallerProfile.cnam.length && this.shakenStirProfile.hasStatusEmpty) {
                    await this.$store.dispatch('deleteComplianceSubscription');
                }
            } catch (e) {
                this.$log.error(e, this.$options.__file, 'handleSubmit');
            } finally {
                this.handleClosed();
            }
        },
    },
};
</script>
